import axios from 'axios';

import { 
  getCpapApiEndpoint, 
  setAxiosDefaultHeaders 
} from './apiBaseUtilities';

import { FirebaseUserProps } from './entityUtilities';
import { debugLog } from './debugUtilities';
const cpapApiEndpoint = getCpapApiEndpoint();



/** What `DELETE /users/me` reports back (cribsy-api docs/ACCOUNT_DELETION.md). */
export interface AccountDeletionReport {
  actor: string;
  uid?: string;
  userId?: string;
  storage: Array<{ bucket: string; prefix?: string; path?: string; deleted: number; error?: string }>;
  assessments: number;
  subjects: number;
  notifications: number;
  chatSessions: number;
  chatMessages: number;
  enrollmentsMarked: number;
  users: number;
  authDeleted: boolean;
  errors: string[];
  finishedAt: string;
}

/**
 * Deletes the signed-in parent's account server-side: every video and result in Storage, all children and their
 * assessments, notifications, chat history, the user record and the Firebase Auth user (decisions D22-D24 in
 * cribsy-api). Throws on a transport or HTTP error so the caller can tell the parent nothing was deleted.
 */
export async function deleteMyAccount(firebaseUser: FirebaseUserProps): Promise<AccountDeletionReport> {
  if (!cpapApiEndpoint) {
    throw new Error('API endpoint is not configured');
  }
  const { uid, bearerToken } = firebaseUser;
  setAxiosDefaultHeaders(uid, bearerToken);
  const response = await axios.delete<AccountDeletionReport>(`${cpapApiEndpoint}users/me`);
  debugLog('Account deleted:', response.data);
  return response.data;
}

  export async function deleteAssessment(firebaseUser:FirebaseUserProps, assessmentId:string){
    if(!cpapApiEndpoint){
      return false;
    }
  
    const url = `${cpapApiEndpoint}assessments/${assessmentId}`;
    try{
      const {uid, bearerToken } = firebaseUser;
      setAxiosDefaultHeaders(uid, bearerToken);
      const response = await axios.delete(url);
  
      // debugLog('The respons', response);
      if(response.status === 204){
        debugLog('Deleted asmt');
        return true;
      }
  
      return false;
    }catch(error){
      debugLog('API ERROR:',error);
    }
    return false;
  }


  export async function deleteNotifications(firebaseUser:any, emmauserId: string){


    const url = `${cpapApiEndpoint}/notifications`;
    //the api gets notifications for the user specified by the uid in the axios headers
    
    debugLog('Delete notifications URL:', url);
    
  
    const {uid, bearerToken } = firebaseUser;
    setAxiosDefaultHeaders(uid, bearerToken);
    try{
  
      const response = await axios.get(url);
      let alerts = response.data;
      for (const alert of alerts){
        debugLog('notification:', alert);
        //delete?
        let notId = alert.notificationId;
  
        debugLog('Deleting notification:', notId);
        await deleteNotification(firebaseUser, notId);
      }
  
    }catch(err){
      debugLog('Error deleting notifications:', err);
    }
  
  }

export async function deleteNotification(firebaseUser: FirebaseUserProps, notificationId: string){

  if(!cpapApiEndpoint){
    return false;
  }

  const url = `${cpapApiEndpoint}notifications/${notificationId}`;
  try{
    const {uid, bearerToken } = firebaseUser;
    setAxiosDefaultHeaders(uid, bearerToken);
    const response = await axios.delete(url);

    // debugLog('The respons', response);
    if(response.status === 204){
      debugLog('deleted notification:', notificationId);
      return true;
    }

    return false;
  }catch(error){
    debugLog('API ERROR:',error);
  }
  return false;
}
